import ApiService from "@/common/api.service";
import { FETCH_CONSIGNMENTS, REPORT_CONSIGNMENT } from "../actions.type";
import { SET_CONSIGNMENTS } from "../mutations.type";

const state = {
  consignments: []
};

const getters = {
  consignments(state) {
    return state.consignments;
  }
};

const mutations = {
  [SET_CONSIGNMENTS](context, consignments) {
    state.consignments = consignments;
  }
};

const actions = {
  [FETCH_CONSIGNMENTS](context, filters) {
    return ApiService.post("consignment/list", filters).then(consignments => {
      context.commit(SET_CONSIGNMENTS, consignments);
      return Promise.resolve(consignments);
    });
  },

  [REPORT_CONSIGNMENT](context, data) {
    return ApiService.post("consignment/reportConsignment", data);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
